import React from "react";
import { getTimeBetweenInSec } from "utils/dateUtils";
import moment from "moment";
import { Label, Icon } from "semantic-ui-react";

const styles = {
	resultLate: {
		fontSize: "1.2em",
		backgroundColor: "darkred",
		padding: "2px 7px",
		borderRadius: "15px",
		margin: "5px",
		color: "white",
	},
	resultWaiting: {
		backgroundColor: "darkorange",
		padding: "2px 7px",
		borderRadius: "15px",
		margin: "5px",
		color: "white",
	},
};

const FastResultInfo = ({ tube, t }) => {
	const WaitingResultStatusEnum = { notDefined: 0, waiting: 1, toRead: 2, tooLate: 3 };
	const timingTube = (tube) =>
		Math.floor(Math.abs(getTimeBetweenInSec(moment(tube.sampling_time).add(tube.properties.timer_before_result, "m")) / 60));
	const getWaitingResultStatus = (tube) => {
		if (tube) {
			if (tube.sampling_time && getTimeBetweenInSec(moment(tube.sampling_time).add(tube.properties.timer_before_result, "m")) > 0)
				return WaitingResultStatusEnum.waiting;
			if (
				tube.sampling_time &&
				getTimeBetweenInSec(moment(tube.sampling_time).add(tube.properties.timer_before_result, "m")) < 0 &&
				getTimeBetweenInSec(moment(tube.sampling_time).add(tube.properties.timer_before_result, "m")) > -900
			)
				return WaitingResultStatusEnum.toRead;
			if (tube.sampling_time && getTimeBetweenInSec(moment(tube.sampling_time).add(tube.properties.timer_before_result, "m")) < -900)
				return WaitingResultStatusEnum.tooLate;
		}
		return WaitingResultStatusEnum.notDefined;
	};
	const status = getWaitingResultStatus(tube);
	switch (status) {
		case WaitingResultStatusEnum.waiting:
			//ATTENDRE
			return (
				<div style={styles.fastResult}>
					<Label color="grey">
						<Icon name="wait" />
						{t("foldersOverview.resultWaiting")}{" "}
					</Label>
					<br />
					<span style={styles.resultWaiting}>
						{timingTube(tube)}
						{t("foldersOverview.min")}
					</span>
					<div>{t("foldersOverview.providerBarcode") + tube.provider_barcode}</div>
					<div>
						{t("foldersOverview.sampler") + tube.sampler?.first_name} {tube.sampler?.last_name}
					</div>
				</div>
			);
		case WaitingResultStatusEnum.toRead:
			//Prélever
			return (
				<div style={styles.fastResult}>
					<Label color="green">
						<Icon name="play" />
						{t("foldersOverview.testToRead")} ({timingTube(tube) + t("foldersOverview.min")})
					</Label>
					<div>{t("foldersOverview.providerBarcode") + tube.provider_barcode}</div>
					<div>
						{t("foldersOverview.sampler") + tube.sampler?.first_name} {tube.sampler?.last_name}
					</div>
				</div>
			);
		case WaitingResultStatusEnum.tooLate:
			//Prélever en retard
			return (
				<div style={styles.fastResult}>
					<Label color="red">
						<Icon name="warning" />
						{t("foldersOverview.lateReading")} ({timingTube(tube) + t("foldersOverview.min")})
					</Label>
					<div>{t("foldersOverview.providerBarcode") + tube.provider_barcode}</div>
					<div>
						{t("foldersOverview.sampler") + tube.sampler?.first_name} {tube.sampler?.last_name}
					</div>
				</div>
			);
		default:
			return;
	}
};

export default FastResultInfo;
